module.exports = __webpack_public_path__ + "images/wevi_small30221d77cd9fe4da1139abd006edcdfa.png";